import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";



@Injectable()
export class TrackingService {
  private headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  data:any = {
    "ask": "Success",
    "message": null,
    "tracking": [
        {
            "status": "pick up",
            "message": "not received yet",
            "location": "",
            "updatedAt": ""
        },
        {
            "status": "In transit",
            "message": "in transit",
            "location": "",
            "updatedAt": ""
        },
        {
          "status": "Processing",
          "message": "in transit",
          "location": "",
          "updatedAt": ""
      }
     ]
}
  constructor(private http: HttpClient) { }


  getTrackingDetails(trackingNumber:String)
  {
      return this.data;
  }

  getTrackingNumberInformation(trackingNumber){
    return this.http.get('/api/tracking/details?trackingNumber='+trackingNumber,this.headerOptions);
  }
}
